import React, { FC } from "react";

interface NotFoundProps {}

const NotFound: FC<NotFoundProps> = () => <div>NotFound Component</div>;

export default NotFound;
